import { render, staticRenderFns } from "./ActionsMenu.vue?vue&type=template&id=1572e6a4&scoped=true&"
import script from "./ActionsMenu.vue?vue&type=script&lang=js&"
export * from "./ActionsMenu.vue?vue&type=script&lang=js&"
import style0 from "./ActionsMenu.vue?vue&type=style&index=0&id=1572e6a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1572e6a4",
  null
  
)

export default component.exports